/**
 * @generated SignedSource<<76a1017fbc61c05cef29731f136f49d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PromotionProductEventUpsertDialog_promotion$data = {
  readonly id: string;
  readonly nextOccurrences: ReadonlyArray<any>;
  readonly productEvent: {
    readonly discounts: ReadonlyArray<{
      readonly amount: number;
      readonly product: {
        readonly id: string;
      };
    }>;
    readonly durationDays: number | null;
    readonly durationHours: number | null;
    readonly offsetHours: number;
    readonly title: string;
  } | null;
  readonly startAt: any;
  readonly " $fragmentType": "PromotionProductEventUpsertDialog_promotion";
};
export type PromotionProductEventUpsertDialog_promotion$key = {
  readonly " $data"?: PromotionProductEventUpsertDialog_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionProductEventUpsertDialog_promotion">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionProductEventUpsertDialog_promotion",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1
        }
      ],
      "kind": "ScalarField",
      "name": "nextOccurrences",
      "storageKey": "nextOccurrences(limit:1)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionProductEvent",
      "kind": "LinkedField",
      "name": "productEvent",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationHours",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "durationDays",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offsetHours",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductDiscount",
          "kind": "LinkedField",
          "name": "discounts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};
})();

(node as any).hash = "cddb948ed2c0e44844be3d655f75b682";

export default node;
